<template>
  <div v-if="show" class="fixed inset-0 z-50 flex items-center justify-center">
    <div class="absolute inset-0 bg-black/50 backdrop-blur-sm" @click="close"></div>
    <div class="relative rounded-2xl shadow-2xl w-full max-w-md mx-4 overflow-hidden"
         :class="isDark ? 'bg-gray-800' : 'bg-white'">
      <button @click="close" 
              class="absolute top-4 right-4 p-2 rounded-full transition-colors"
              :class="isDark ? 'hover:bg-gray-700 text-gray-400' : 'hover:bg-gray-100 text-gray-500'">
        <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
      
      <div class="p-8">
        <div class="text-center mb-8">
          <div class="w-16 h-16 mx-auto mb-4 rounded-full bg-gradient-to-br from-green-400 to-green-600 flex items-center justify-center">
            <svg xmlns="http://www.w3.org/2000/svg" class="w-8 h-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
            </svg>
          </div>
          <h2 class="text-2xl font-bold" :class="isDark ? 'text-white' : 'text-gray-800'">
            {{ isRegister ? '注册' : '登录' }}
          </h2>
          <p class="mt-2" :class="isDark ? 'text-gray-400' : 'text-gray-500'">
            {{ isRegister ? '创建新账户' : '欢迎回来' }}
          </p>
        </div>

        <form @submit.prevent="handleSubmit" class="space-y-6">
          <div v-if="isRegister">
            <label class="block text-sm font-medium mb-2" :class="isDark ? 'text-gray-300' : 'text-gray-700'">
              用户名
            </label>
            <input 
              v-model="form.name"
              type="text" 
              placeholder="请输入用户名"
              class="w-full px-4 py-3 rounded-lg border focus:outline-none focus:ring-2 focus:ring-green-500 transition-all"
              :class="isDark ? 'bg-gray-700 border-gray-600 text-white placeholder-gray-500' : 'bg-gray-50 border-gray-200 text-gray-800 placeholder-gray-400'"
            />
          </div>
          
          <div>
            <label class="block text-sm font-medium mb-2" :class="isDark ? 'text-gray-300' : 'text-gray-700'">
              邮箱
            </label>
            <input 
              v-model="form.email"
              type="email" 
              placeholder="请输入邮箱"
              class="w-full px-4 py-3 rounded-lg border focus:outline-none focus:ring-2 focus:ring-green-500 transition-all"
              :class="isDark ? 'bg-gray-700 border-gray-600 text-white placeholder-gray-500' : 'bg-gray-50 border-gray-200 text-gray-800 placeholder-gray-400'"
            />
          </div>
          
          <div>
            <label class="block text-sm font-medium mb-2" :class="isDark ? 'text-gray-300' : 'text-gray-700'">
              密码
            </label>
            <input 
              v-model="form.password"
              type="password" 
              placeholder="请输入密码"
              class="w-full px-4 py-3 rounded-lg border focus:outline-none focus:ring-2 focus:ring-green-500 transition-all"
              :class="isDark ? 'bg-gray-700 border-gray-600 text-white placeholder-gray-500' : 'bg-gray-50 border-gray-200 text-gray-800 placeholder-gray-400'"
            />
          </div>

          <button 
            type="submit"
            class="w-full py-3 bg-green-600 hover:bg-green-700 text-white font-medium rounded-lg transition-colors"
          >
            {{ isRegister ? '注册' : '登录' }}
          </button>
        </form>

        <div class="mt-6 text-center">
          <p class="text-sm" :class="isDark ? 'text-gray-400' : 'text-gray-500'">
            {{ isRegister ? '已有账户？' : '还没有账户？' }}
            <button @click="toggleMode" class="text-green-500 hover:text-green-600 font-medium ml-1">
              {{ isRegister ? '立即登录' : '立即注册' }}
            </button>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, watch } from 'vue'
import { useTheme } from '../composables/useTheme'
import { useAuth } from '../composables/useAuth'

export default {
  name: 'AuthModal',
  props: {
    show: Boolean
  },
  setup(props, { emit }) {
    const { isDark } = useTheme()
    const { login, register } = useAuth()
    
    const isRegister = ref(false)
    const form = ref({
      name: '',
      email: '',
      password: ''
    })

    const close = () => {
      emit('close')
    }

    const toggleMode = () => {
      isRegister.value = !isRegister.value
      form.value = { name: '', email: '', password: '' }
    }

    const handleSubmit = () => {
      let success = false
      if (isRegister.value) {
        success = register(form.value.email, form.value.password, form.value.name)
      } else {
        success = login(form.value.email, form.value.password)
      }
      
      if (success) {
        emit('success')
        close()
      } else {
        alert('请填写完整信息')
      }
    }

    watch(() => props.show, (newVal) => {
      if (!newVal) {
        form.value = { name: '', email: '', password: '' }
        isRegister.value = false
      }
    })

    return {
      isDark,
      isRegister,
      form,
      close,
      toggleMode,
      handleSubmit
    }
  }
}
</script>
